import React from "react";
import Hammer from "../../Shared/SvgIcons/Hammer";

const UserInfo = () => {
  return (
    <div className="flex flex-auto items-center gap-1.5">
      <Hammer className={"h-6 w-6"} />
      <div className="relative font-pop text-xl font-medium text-textBlack">
        Ben88{" "}
        <span className="absolute -top-1 left-full font-pop text-[13px] font-medium text-primary">
          456
        </span>
      </div>
    </div>
  );
};

export default UserInfo;
